import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { HpSharedFeaturedModuleContent } from './HpSharedFeaturedModuleContent.tsx';

import { type HpSharedFeaturedModule_viewer$key } from './__generated__/HpSharedFeaturedModule_viewer.graphql.ts';
import { type HpSharedFeaturedModule_user$key } from './__generated__/HpSharedFeaturedModule_user.graphql.ts';

const viewerFragment = graphql`
    fragment HpSharedFeaturedModule_viewer on Viewer {
        ...HpSharedFeaturedModuleContent_viewer
    }
`;

const userFragment = graphql`
    fragment HpSharedFeaturedModule_user on User {
        ...HpSharedFeaturedModuleContent_user
    }
`;

export const HpSharedFeaturedModule: FC<{
    viewer: HpSharedFeaturedModule_viewer$key | null;
    user?: HpSharedFeaturedModule_user$key | null;
    isClient: boolean;
}> = ({ viewer: viewerRef, user: userRef, isClient }) => {
    const viewer = useFragment(viewerFragment, viewerRef);
    const user = useFragment(userFragment, userRef);

    //isClient ensures that the module is rendered only after client side refetch
    if (!isClient) {
        return null;
    }

    return <HpSharedFeaturedModuleContent viewer={viewer} user={user} />;
};
